<template>
      <div class="companyCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'company', params: {} }">
          Company
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'companyCreate', params: {} }">
            Create Company
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Company</v-card-title>
          <v-card-text>
            <company-form></company-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import CompanyForm from './CompanyForm.vue';

    export default {
      name: 'company',
      components: {
        CompanyForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    